export default __webpack_public_path__ + "static/media/search.5224c680.svg";